import { isShippingFeeToggleEnabled } from './toggleService.js';
import { trackCustomer } from './eventTracker.js';

// @ts-ignore
async function publishMetrics(sid, cartId, site, page, deviceType, customer) {
    const toggleResult = await isShippingFeeToggleEnabled(cartId, site.id);
    if (toggleResult.isToggleEnabled) {
        trackCustomer(sid, site, page, deviceType, customer, toggleResult.variantName);
    }
}

export { publishMetrics };
//# sourceMappingURL=index.js.map
